"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function useOutsideClick(callback) {
    var ref = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        var handleClick = function (event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        return function () {
            document.removeEventListener("click", handleClick, true);
        };
    }, [ref]);
    return ref;
}
exports.default = useOutsideClick;
